import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const csvSummaryDialogStyle = () => ({
	bodyWrapper: {
		padding: '0 16px',
	},
	errors: {
		borderTop: `1px solid ${blackColors[6]}`,
		textAlign: 'center',
		'& > div': {
			textAlign: 'left',
			padding: '8px 0',
			height: '104px',
			overflow: 'auto',
			marginBottom: '16px',
			'& > div': {
				'& > div': {
					marginBottom: '16px',
					'&:last-of-type': {
						marginBottom: 0,
					},
				},
			},
		},
	},
	errorsHeader: {
		marginBottom: 8,
	},
});

export default csvSummaryDialogStyle;
